import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz33 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel34'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel32'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Rs 500 Note Puzzle </h1>
    
    <div class="text">
        <p>A Lady (L) bought an item of Rs 100 from the Shopkeeper (C). She paid him through a 500 Rs Note. Realizing
            that he did not have change, the shopkeeper C got change for that note from another shopkeeper (S) and paid
            Rs 400 to the Lady.</p>
        <p>After a few days, S realized that the note is fake, And this railed at C and took 500 Rs back from him.</p>
        <p>So in this whole process how much money did C loose in the end?</p>
        <p>&nbsp;<br/>
            &nbsp;<br/>
            &nbsp;<br/>
            &nbsp;<br/>
            &nbsp;</p>
            <div class="containers">
        <p>Answer: 500<br/>
            Explanation:<br/>
            The total loss for shopkeeper = 500 ( given back to the person who had
            provided the change )</p>
        <p>Consider a transaction box, the lady came with a counterfeit 500 Rs note which can be considered of 0
            value.<br/>
            Now the lady took the item (cost of the item 100 Rs ) and 400 Rs (the change given by
            shopkeeper(C) to the lady)<br/>
            from the transaction box, total of 500 Rs. Now the equivalent amount should be
            lost by someone, thus shopkeeper(C) lost 500 Rs. Another shopkeeper(S) gave 500 Rs and took back the same
            amount hence no loss for him.</p>
        </div>
    </div>
</article>
        </div>
    )
}

export default Puz33
